import React from 'react'
import { isNumber } from 'lodash'
import { PRICE } from '../../constants/modes'
import CustomButton from '../../../customButton/ui/main/CustomButton'
import { useLanguageControls } from '../../../../../hooks/useLanguageControls'
import content from '../../constants/content'
import { formatPrice } from '../../utils/formatPrice'
import { gtmFunctions } from '../../../../../constants/analytics/GTM'
import { getProductCurrentState } from '../../utils/getProductCurrentState'
import { useContent } from '../../../../../redux/reducer/content'

const { brandButton } = content

export default function Footer({
  oldPrice,
  brand_link,
  newPrice,
  isChangePricePlace,
  isVisibleInfo = true,
  basketCallback,
  sku,
}) {
  const Wrapper = getWrapper(arguments[0])

  const { getLocalizedCurrency } = useLanguageControls()
  const currentCurrency = getLocalizedCurrency()
  const isValidOldPrice = isNumber(oldPrice) && oldPrice > 0
  const isValidNewPrice = isNumber(newPrice) && newPrice > 0

  const formattedOldPrice = formatPrice(oldPrice)
  const formattedNewPrice = formatPrice(newPrice)

  const { state } = useContent()
  const { isGameState, gameName, isBeautyRoutineState } = getProductCurrentState(state)

  const brandClick = () => {
    if (isGameState) {
      gtmFunctions.GTMGamesBrand({
        name: gameName,
        item_sku: sku,
      })
    }

    if (isBeautyRoutineState) {
      gtmFunctions.GTMBeautyRoutineBrand({
        item_sku: sku,
      })
    }
  }

  //todo: отрефакторить
  return (
    <Wrapper>
      {oldPrice !== newPrice &&
        (isChangePricePlace
          ? isVisibleInfo &&
            isValidNewPrice && (
              <div className={'product__price'}>{`${formattedNewPrice} ${currentCurrency}`}</div>
            )
          : isVisibleInfo &&
            isValidOldPrice && (
              <div
                className={'product__old-price'}
              >{`${formattedOldPrice} ${currentCurrency}`}</div>
            ))}

      <div className={'product__buy'}>
        {oldPrice !== newPrice &&
          (isChangePricePlace && isVisibleInfo
            ? isValidOldPrice && (
                <div
                  className={'product__old-price'}
                >{`${formattedOldPrice} ${currentCurrency}`}</div>
              )
            : isValidNewPrice && (
                <div className={'product__price'}>{`${formattedNewPrice} ${currentCurrency}`}</div>
              ))}

        {oldPrice === newPrice && isVisibleInfo && isValidNewPrice && (
          <div className={'product__price'}>{`${formattedNewPrice} ${currentCurrency}`}</div>
        )}

        {isVisibleInfo && <div className={'product__del'} />}

        {isVisibleInfo && (
          <CustomButton
            className={'product__buy-button'}
            icon={'buttons/product-basket'}
            onClick={basketCallback}
          />
        )}
      </div>

      {!!brand_link && (
        <CustomButton
          {...brandButton.attr}
          link={brand_link}
          stopPropagation
          onClick={brandClick}
        />
      )}
    </Wrapper>
  )
}

function getWrapper({ mode }) {
  const wrappers = {
    [PRICE]: ({ children }) => <div className={'product__footer'}>{children}</div>,
    default: ({ children }) => <>{children}</>,
  }

  return wrappers[mode] ?? wrappers.default
}
